import { render } from "./categorizedMessagesList.vue?vue&type=template&id=bc20f150"
import script from "./categorizedMessagesList.vue?vue&type=script&lang=js"
export * from "./categorizedMessagesList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__